import {
  Button,
  Checkbox,
  Input,
  Calendar,
  CurrencyInput,
  DatePicker,
  Drawer,
  DropdownMenu,
  FocusModal,
  IconBadge,
  IconButton,
  ProgressAccordion,
  ProgressTabs,
  RadioGroup,
  Select,
  StatusBadge,
  Switch,
  Tabs,
  Table,
  Textarea,
  Toast,
  Tooltip,
  TooltipProvider,
} from "@medusajs/ui"

export const MedusaButton = Button
export const MedusaCheckbox = Checkbox
export const MedusaInput = Input
export const MedusaCalendar = Calendar
export const MedusaCurrencyInput = CurrencyInput
export const MedusaDatePicker = DatePicker
export const MedusaDrawer = Drawer
export const MedusaDropdownMenu = DropdownMenu
export const MedusaFocusModal = FocusModal
export const MedusaIconBadge = IconBadge
export const MedusaIconButton = IconButton
export const MedusaProgressAccordion = ProgressAccordion
export const MedusaProgressTabs = ProgressTabs
export const MedusaRadioGroup = RadioGroup
export const MedusaSelect = Select
export const MedusaStatusBadge = StatusBadge
export const MedusaSwitch = Switch
export const MedusaTabs = Tabs
export const MedusaTable = Table
export const MedusaTextarea = Textarea
export const MedusaToast = Toast
export const MedusaTooltip = Tooltip
export const MedusaTooltipProvider = TooltipProvider
